/* eslint-disable eqeqeq */
import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { I_KYCAttempts } from "@models/I_KYCAttempts";
import { verificationStatuses } from "@models/MasterData";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { VerificationLiterals } from "@models/payments/VerificationLiterals";
import { VerificationOption } from "@models/payments/VerificationOption";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
@Component({
  selector: "cs-document-header",
  templateUrl: "./cs-document-header.html",
  styleUrls: ["./cs-document-header.scss"],
  standalone: true,
  host: {
    class: "cs-document-header background-color-white color-dark",
  },
  imports: [TranslateModule, CommonModule],
})
export class CsDocumentHeaderComponent {
  @Input() isMobile: boolean;
  @Input() KYC: I_KYCAttempts;
  @Input() verificationLiterals: VerificationLiterals;
  @Input() verificationOptions: VerificationOption[];
  @Output() verificationOption: EventEmitter<any> = new EventEmitter();

  verificationStatus: verificationStatuses;
  verStatus = verificationStatuses;
  verificationWarningMessage: string;

  verificationOptionSelected: VerificationOption;

  private globalVars!: GlobalVarsModel;
  public translate = inject(TranslateService);

  verificationOptionClicked(verOpt: VerificationOption) {
    this.verificationOptions.forEach((verificationOption) => {
      verificationOption.type === verOpt.type
        ? ((verificationOption.selected = true), (this.verificationOptionSelected = verificationOption))
        : (verificationOption.selected = false);
    });
    this.verificationOption.emit(this.verificationOptionSelected);
  }
}
